export const calendar = {
  title: 'Mój Kalendarz',
  subtitle: 'Zarządzaj swoją dostępnością i synchronizuj swoje kalendarze',
  calendar: {
    today: 'Dzisiaj',
    month: 'Miesiąc',
    week: 'Tydzień',
    day: 'Dzień',
    selectDates: 'Wybierz daty',
    blockDates: 'Zablokuj daty',
    unblockDates: 'Odblokuj te daty',
    addNote: 'Dodaj notatkę',
    selectEvent: 'Wybierz zdarzenie',
    nMonths: 'miesiące',
    oneMonth: '1 miesiąc',
    months: { january: 'Styczeń', february: 'Luty', march: 'Marzec', april: 'Kwiecień', may: 'Maj', june: 'Czerwiec', july: 'Lipiec', august: 'Sierpień', september: 'Wrzesień', october: 'Październik', november: 'Listopad', december: 'Grudzień' },
    days: { monday: 'Pon', tuesday: 'Wto', wednesday: 'Śro', thursday: 'Czw', friday: 'Pią', saturday: 'Sob', sunday: 'Nie' }
  },
  sync: { title: 'Synchronizacja iCal', description: 'Podłącz swój kalendarz Airbnb lub PMS, aby automatycznie synchronizować swoją dostępność', addConnection: 'Dodaj połączenie', noConnections: 'Brak połączeń', icalUrl: 'URL iCal', icalUrlPlaceholder: 'https://www.airbnb.com/calendar/ical/...', platform: 'Platforma', platformPlaceholder: 'Np.: Airbnb, Booking.com, PMS...', syncNow: 'Synchronizuj teraz', lastSync: 'Ostatnia synchronizacja', eventsImported: 'zdarzenia zaimportowane', status: { synced: 'Zsynchronizowane', pending: 'Oczekiwanie', error: 'Błąd', syncing: 'Synchronizacja...' }, remove: 'Usuń', edit: 'Edytuj' },
  exchanges: { title: 'Przyszłe Wymiany', noExchanges: 'Żadne wymiany nie zaplanowane', viewProfile: 'Pokaż profil', sendMessage: 'Wyślij wiadomość', confirm: 'Potwierdź', decline: 'Odrzuć', cancel: 'Anuluj', guests: 'podróżnicy', status: { confirmed: 'Potwierdzony', pending: 'Oczekiwanie', proposal: 'Propozycja', blocked: 'Zablokowany' } },
  legend: { title: 'Legenda', available: 'Dostępne', confirmed: 'Potwierdzona wymiana', pending: 'Oczekujące żądanie', proposal: 'Propozycja', blocked: 'Zablokowane daty' },
  blockModal: { title: 'Zablokuj daty', reason: 'Powód (opcjonalnie)', reasonPlaceholder: 'Np.: Remonty, urlop osobisty...', from: 'Od', to: 'Do', block: 'Zablokuj', cancel: 'Anuluj' },
  notifications: { datesBlocked: 'Daty zablokowane pomyślnie', datesUnblocked: 'Daty odblokowane pomyślnie', syncSuccess: 'Synchronizacja udana', syncError: 'Błąd synchronizacji', connectionAdded: 'Połączenie dodane pomyślnie', connectionRemoved: 'Połączenie usunięte', exchangeConfirmed: 'Wymiana potwierdzona', exchangeDeclined: 'Wymiana odrzucona' },
  details: 'Szczegóły',
  upcomingExchanges: 'Przyszłe Wymiany',
  noExchangesPlanned: 'Żadne wymiany nie zaplanowane',
  daysSelected: 'dni wybrane',
  daySelected: 'dzień wybrany',
  from: 'Od',
  to: 'Do',
  reasonOptional: 'Powód (opcjonalnie)',
  reasonPlaceholder: 'Np.: Remonty, urlop osobisty...',
  block: 'Zablokuj',
  cancel: 'Anuluj',
  namePlaceholder: 'Nazwa (np.: Airbnb)',
  filters: 'Filtry',
  actions: 'Akcje',
  connections: 'Połączenia'
};

export default calendar;
